import React from 'react';

const Spinner = () => {
  return (
    <>
      <div class="d-flex justify-content-center my-5 py-5">
        <div class="spinner-border" role="status">
          <span class="sr-only"></span>
        </div>
      </div>
    </>
  );
};

export default Spinner;
